import Vue from 'vue'
import Router from 'vue-router'

/* Layout */
import Layout from '@/layout/Layout'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouters = [{
  path: '/login',
  component: () =>
            import('@/layout/Login'),
  hidden: true
},
{
  path: '/404',
  component: () =>
            import('@/layout/404'),
  hidden: true
},
{
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  name: 'Dashboard',
  hidden: true,
  children: [{
    path: 'dashboard',
    component: () =>
                import('@/views/dashboard/index')
  }]
},
{
  path: '/reconciliation',
  component: Layout,
  redirect: '/reconciliation/index',
  name: 'reconciliation',
  meta: { title: '财务对账' },
  children: [{
    path: 'index',
    name: 'index',
    component: () =>
      import('@/views/reconciliation/index'),
    meta: { title: '代收业务' }
  }
  ]
}
]

export default new Router({
  // mode: 'history', //后端支持可開
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouters
})

export { lastRouters }
  from './lastRouters'
export { asyncRouters }
  from './asyncRouters'
export { routerMap }
  from './routerMap'
